module.exports = __webpack_public_path__ + "static/media/Filled_Arrow_Right.3f8f20b6.svg";